/**
 * Metabolics — UpCart Subscription Inject v3
 * ──────────────────────────────────────────
 * Exact UpCart DOM selectors verified from live site.
 * 
 * 1. Cart items: "Upgrade to Subscribe & Save" banner
 * 2. Upsell tiles: One-time / Subscribe toggle
 * 3. Fetch intercept to inject selling_plan on add
 * 4. Practitioner gating: shows higher discount for tagged customers
 *
 * SETUP — add this in theme.liquid BEFORE the script tag:
 *
 *   <script>
 *     window.__mbSub = {
 *       isPractitioner: {{ customer.tags | join: ',' | downcase | contains: 'practitioner25' }},
 *       practitionerSubPct: 25,
 *       practitionerOtpPct: 25,
 *       standardSubPct: 15
 *     };
 *   </script>
 *   <script src="{{ 'upcart-subscribe-inject.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  var CACHE = {};
  var CFG = window.__mbSub || {};
  var IS_PRACT = !!CFG.isPractitioner;
  var PRACT_SUB_PCT = CFG.practitionerSubPct || 30;
  var PRACT_OTP_PCT = CFG.practitionerOtpPct || 25;
  var STD_SUB_PCT   = CFG.standardSubPct || 15;

  /* ═══════════════════════════════════════════════
     CSS
     ═══════════════════════════════════════════════ */

  function injectStyles() {
    if (document.getElementById('mb-sub-css')) return;
    var s = document.createElement('style');
    s.id = 'mb-sub-css';
    s.textContent = [
      '.mb-sub{width:100%;font-family:inherit;box-sizing:border-box;touch-action:pan-y}',
      '.mb-sub *,.mb-sub *::before,.mb-sub *::after{box-sizing:border-box;touch-action:pan-y}',
      '.mb-sub__add-btn,.mb-sub__up-btn,.mb-sub__opt,.mb-sub__up-row{touch-action:manipulation}',

      /* Cart item upgrade */
      '.mb-sub--cart{margin:8px 0 4px;padding:8px 10px;background:#f5f0e8;border-radius:8px;border:1px solid #e8e2d6}',
      '.mb-sub__up-row{display:flex;align-items:center;justify-content:space-between;gap:8px;cursor:pointer}',
      '.mb-sub__up-label{display:flex;align-items:center;gap:6px;font-size:11px;font-weight:600;color:#5a4630;line-height:1.3}',
      '.mb-sub__up-icon{width:16px;height:16px;flex-shrink:0;color:#a68d71}',
      '.mb-sub__up-badge{font-size:10px;font-weight:700;color:#fff;background:#a68d71;padding:2px 8px;border-radius:20px;white-space:nowrap;flex-shrink:0}',
      '.mb-sub__up-body{display:none;margin-top:8px;padding-top:8px;border-top:1px solid #e8e2d6}',
      '.mb-sub--cart.is-open .mb-sub__up-body{display:block}',
      '.mb-sub__up-freq{width:100%;padding:7px 8px;border:1px solid #d9d3cb;border-radius:6px;font-size:11px;color:#1a1a1a;background:#fff;cursor:pointer;margin-bottom:6px}',
      '.mb-sub__up-btn{width:100%;padding:8px 12px;background:#a68d71;color:#fff;border:none;border-radius:6px;font-size:11px;font-weight:600;cursor:pointer;transition:background .2s}',
      '.mb-sub__up-btn:hover{background:#8f7a62}',
      '.mb-sub__up-btn:disabled{opacity:.6;cursor:not-allowed}',

      /* Practitioner badge */
      '.mb-sub__pract-badge{display:inline-flex;align-items:center;gap:4px;font-size:9px;font-weight:700;color:#071739;background:#e8ecf2;padding:2px 8px;border-radius:20px;margin-top:4px;text-transform:uppercase;letter-spacing:.03em}',
      '.mb-sub__pract-badge svg{width:10px;height:10px}',

      /* Upsell toggle */
      '.mb-sub--upsell{margin:6px 0 6px}',
      '.mb-sub__toggle{display:flex;border:1.5px solid #d9d3cb;border-radius:8px;overflow:hidden}',
      '.mb-sub__opt{flex:1;display:flex;align-items:center;justify-content:center;padding:8px 6px;cursor:pointer;font-size:11px;font-weight:500;color:#6b6b6b;background:#fff;transition:background .2s,color .2s;text-align:center;line-height:1.2;border-right:1.5px solid #d9d3cb;user-select:none}',
      '.mb-sub__opt:last-child{border-right:none}',
      '.mb-sub__opt input{display:none}',
      '.mb-sub__opt.is-active{background:#a68d71;color:#fff;font-weight:600}',
      '.mb-sub__freq-wrap{display:none;margin-top:6px}',
      '.mb-sub__freq-wrap.is-visible{display:block}',
      '.mb-sub__freq{width:100%;padding:7px 8px;border:1.5px solid #d9d3cb;border-radius:8px;font-size:11px;color:#1a1a1a;background:#fff;cursor:pointer}',
      '.mb-sub__freq:focus{outline:none;border-color:#a68d71}',

      /* Practitioner price override on upsells */
      '.mb-sub__price-row{margin-top:4px;font-size:13px;line-height:1.3}',
      '.mb-sub__price-rrp{text-decoration:line-through;color:#999;font-size:12px;margin-right:4px}',
      '.mb-sub__price-now{font-weight:700;color:#a68d71}',
      '.mb-sub__price-label{font-size:10px;color:#a68d71;font-weight:600}',

      /* Variant selector */
      '.mb-sub__variant-wrap{margin:6px 0}',
      '.mb-sub__variant-select{width:100%;padding:7px 8px;border:1.5px solid #d9d3cb;border-radius:8px;font-size:11px;color:#1a1a1a;background:#fff;cursor:pointer;appearance:auto}',
      '.mb-sub__variant-select:focus{outline:none;border-color:#a68d71}',

      /* Our own Add button (shown when Subscribe is active) */
      '.mb-sub__add-btn{display:none;width:100%;padding:10px 16px;background:#a68d71;color:#fff;border:none;border-radius:24px;font-size:13px;font-weight:600;cursor:pointer;transition:background .2s;margin-top:6px;text-align:center}',
      '.mb-sub__add-btn:hover{background:#8f7a62}',
      '.mb-sub__add-btn:disabled{opacity:.6;cursor:not-allowed}',
      '.mb-sub__add-btn.is-visible{display:block}'
    ].join('\n');
    document.head.appendChild(s);
  }

  /* ═══════════════════════════════════════════════
     Product data
     ═══════════════════════════════════════════════ */

  function getProduct(handle) {
    if (CACHE[handle]) return Promise.resolve(CACHE[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d) CACHE[handle] = d; return d; })
      .catch(function () { return null; });
  }

  function getBestPlans(groups) {
    var seen = {};
    groups.forEach(function (g) {
      (g.selling_plans || []).forEach(function (p) {
        // Normalize to a frequency key like "1-month", "2-month", "3-month"
        // Handles: "Deliver every month", "Delivery every 1 month",
        //          "Deliver every 2 months", "Delivery every 3 months"
        var raw = (p.name || '').toLowerCase().trim();
        var freqKey = normalizeFrequency(raw);
        var pct = getPct(p);
        if (!seen[freqKey] || pct > (seen[freqKey]._pct || 0)) {
          var copy = {};
          for (var k in p) copy[k] = p[k];
          copy._pct = pct;
          copy._displayName = freqToLabel(freqKey);
          seen[freqKey] = copy;
        }
      });
    });
    return Object.keys(seen).map(function (k) { return seen[k]; });
  }

  /**
   * Normalize plan name to a frequency key like "1-month"
   * "Deliver every month" → "1-month"
   * "Delivery every 2 months" → "2-month"
   * "Deliver every 3 months" → "3-month"
   */
  function normalizeFrequency(name) {
    // Try to extract number + unit
    var m = name.match(/every\s+(\d+)\s*(day|week|month|year)/i);
    if (m) return m[1] + '-' + m[2].toLowerCase();
    // "every month" without a number = 1
    m = name.match(/every\s+(day|week|month|year)/i);
    if (m) return '1-' + m[1].toLowerCase();
    // Fallback: use the cleaned name
    return name.replace(/[,\-–—]\s*(save|discount).*$/i, '').replace(/\s+/g, ' ').trim();
  }

  function freqToLabel(key) {
    var m = key.match(/^(\d+)-(day|week|month|year)$/);
    if (!m) return key;
    var n = parseInt(m[1]);
    var unit = m[2];
    if (n === 1) return 'Deliver every ' + unit;
    return 'Deliver every ' + n + ' ' + unit + 's';
  }

  function getPct(plan) {
    if (!plan || !plan.price_adjustments || !plan.price_adjustments.length) return 0;
    var a = plan.price_adjustments[0];
    return (a.value_type === 'percentage' && a.value > 0) ? a.value : 0;
  }

  /**
   * Returns the effective discount % to DISPLAY.
   * Practitioners get their rate; standard customers see the plan's rate.
   */
  function getDisplayPct(planPct) {
    if (IS_PRACT) return PRACT_SUB_PCT;
    return planPct || STD_SUB_PCT;
  }

  function practBadgeHtml() {
    if (!IS_PRACT) return '';
    return '<span class="mb-sub__pract-badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>Practitioner rate</span>';
  }

  function money(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  /**
   * Injects practitioner strikethrough pricing into an upsell tile.
   * Finds UpCart's price element and replaces/augments it.
   */
  function injectPractPrice(tile, basePriceCents, discountPct) {
    var discounted = Math.round(basePriceCents * (1 - discountPct / 100));

    // Find or create our price row
    var priceRow = tile.querySelector('.mb-sub__price-row');
    if (!priceRow) {
      priceRow = document.createElement('div');
      priceRow.className = 'mb-sub__price-row';

      // Find UpCart's existing price element and insert after it
      var upcartPrice = tile.querySelector('[class*="price"], [class*="Price"]');
      if (upcartPrice) {
        // Hide UpCart's price
        upcartPrice.style.display = 'none';
        upcartPrice.parentNode.insertBefore(priceRow, upcartPrice.nextSibling);
      } else {
        tile.appendChild(priceRow);
      }
    }

    priceRow.innerHTML =
      '<span class="mb-sub__price-rrp">' + money(basePriceCents) + '</span>' +
      '<span class="mb-sub__price-now">' + money(discounted) + '</span> ' +
      '<span class="mb-sub__price-label">save ' + discountPct + '%</span>';
  }

  /**
   * Refresh UpCart's cart display without clicking the cart icon.
   * UpCart listens for cart changes via fetch interception and events.
   */
  function refreshUpcart() {
    // Dispatch standard Shopify/UpCart events
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
    window.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('upcart:refresh'));

    // Trigger a cart fetch which UpCart monitors
    fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }).catch(function() {});

    // Also try UpCart's internal method if available
    if (window.UpCart && typeof window.UpCart.refreshCart === 'function') {
      window.UpCart.refreshCart();
    }
  }

  /* ═══════════════════════════════════════════════
     1. CART ITEMS — Upgrade to Subscribe
     ═══════════════════════════════════════════════ */

  function processCartItems() {
    var items = document.querySelectorAll('.upcart-internal-cart-item');

    items.forEach(function (item) {
      // GUARD: already has our banner
      if (item.querySelector('.mb-sub--cart')) return;

      // Find product link
      var link = item.querySelector('a[href*="/products/"]');
      if (!link) return;

      var m = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
      if (!m) return;
      var handle = m[1];

      // Skip if already a subscription item — check for selling plan text from UpCart
      var sellingPlanBadge = item.querySelector('[class*="selling-plan"], [class*="subscription"]');
      if (sellingPlanBadge) return;

      getProduct(handle).then(function (product) {
        if (!product) return;
        var groups = product.selling_plan_groups || [];
        if (groups.length === 0) return;

        // Re-check guard after async
        if (item.querySelector('.mb-sub--cart')) return;

        var plans = getBestPlans(groups);
        if (plans.length === 0) return;

        var topPct = getDisplayPct(plans.reduce(function (mx, p) { return Math.max(mx, p._pct || 0); }, 0));

        var banner = document.createElement('div');
        banner.className = 'mb-sub mb-sub--cart';

        var freqId = 'mbf-' + Math.random().toString(36).substr(2, 5);

        banner.innerHTML =
          '<div class="mb-sub__up-row">' +
            '<div class="mb-sub__up-label">' +
              '<svg class="mb-sub__up-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 1l4 4-4 4"/><path d="M3 11V9a4 4 0 014-4h14"/><path d="M7 23l-4-4 4-4"/><path d="M21 13v2a4 4 0 01-4 4H3"/></svg>' +
              'Upgrade to Subscribe & Save' +
            '</div>' +
            (topPct > 0 ? '<span class="mb-sub__up-badge">Save ' + topPct + '%</span>' : '') +
          '</div>' +
          '<div class="mb-sub__up-body">' +
            practBadgeHtml() +
            '<select class="mb-sub__up-freq" id="' + freqId + '">' +
              plans.map(function (p) {
                var displayPct = getDisplayPct(p._pct);
                return '<option value="' + p.id + '">' + (p._displayName || p.name) + (displayPct ? ' (save ' + displayPct + '%)' : '') + '</option>';
              }).join('') +
            '</select>' +
            '<button class="mb-sub__up-btn" data-handle="' + handle + '" data-freq-id="' + freqId + '">Switch to subscription</button>' +
          '</div>';

        // Toggle expand
        banner.querySelector('.mb-sub__up-row').addEventListener('click', function () {
          banner.classList.toggle('is-open');
        });

        // Switch button
        banner.querySelector('.mb-sub__up-btn').addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var btn = e.currentTarget;
          var h = btn.dataset.handle;
          var sel = document.getElementById(btn.dataset.freqId);
          var planId = sel ? sel.value : null;
          if (!planId) return;

          btn.disabled = true;
          btn.textContent = 'Switching…';

          // Get cart, find the OTP line item, remove it, re-add with plan
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var line = null;
              for (var i = 0; i < cart.items.length; i++) {
                if (cart.items[i].handle === h && !cart.items[i].selling_plan_allocation) {
                  line = cart.items[i];
                  break;
                }
              }
              if (!line) throw new Error('Item not found');

              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: line.key, quantity: 0 })
              }).then(function () {
                return fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    id: line.variant_id,
                    quantity: line.quantity,
                    selling_plan: parseInt(planId)
                  })
                });
              });
            })
            .then(function () {
              btn.textContent = 'Done ✓';
              // Refresh UpCart without clicking the cart icon (avoids scroll lock)
              refreshUpcart();
              setTimeout(function() {
                btn.textContent = 'Switch to subscription';
                btn.disabled = false;
              }, 2000);
            })
            .catch(function () {
              btn.textContent = 'Error — try again';
              btn.disabled = false;
            });
        });

        // Insert into the cart item's info area
        var info = item.querySelector('.upcart-internal-component-product-tile__info');
        if (info) {
          info.appendChild(banner);
        } else {
          item.appendChild(banner);
        }
      });
    });
  }

  /* ═══════════════════════════════════════════════
     2. UPSELL TILES — One-time / Subscribe toggle
     ═══════════════════════════════════════════════ */

  function processUpsells() {
    var tiles = document.querySelectorAll('.upcart-internal-component-upsell-tile');

    tiles.forEach(function (tile) {
      // GUARD: already has our toggle
      if (tile.querySelector('.mb-sub--upsell')) return;

      // Get handle from link
      var link = tile.querySelector('a[href*="/products/"]');
      var handle = null;
      if (link) {
        var m = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
        if (m) handle = m[1];
      }
      if (!handle) return;

      getProduct(handle).then(function (product) {
        if (!product) return;
        var groups = product.selling_plan_groups || [];
        if (groups.length === 0) return;

        // Re-check guard after async
        if (tile.querySelector('.mb-sub--upsell')) return;

        var plans = getBestPlans(groups);
        if (plans.length === 0) return;

        var topPct = getDisplayPct(plans.reduce(function (mx, p) { return Math.max(mx, p._pct || 0); }, 0));
        var uid = 'mbs-' + Math.random().toString(36).substr(2, 5);

        // Get price for practitioner price injection
        var variant = product.variants[0];
        var basePrice = parseInt(variant.price) || 0; // cents

        var el = document.createElement('div');
        el.className = 'mb-sub mb-sub--upsell';

        el.innerHTML =
          '<div class="mb-sub__toggle">' +
            '<label class="mb-sub__opt is-active">' +
              '<input type="radio" name="' + uid + '" value="onetime" checked>' +
              '<span>One-time' + (IS_PRACT ? ' <span class="mb-sub__pract-badge" style="margin:0 0 0 4px"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>' + PRACT_OTP_PCT + '% off</span>' : '') + '</span>' +
            '</label>' +
            '<label class="mb-sub__opt">' +
              '<input type="radio" name="' + uid + '" value="subscribe">' +
              '<span>Subscribe' + (topPct > 0 ? ' & save ' + topPct + '%' : '') + '</span>' +
            '</label>' +
          '</div>' +
          '<div class="mb-sub__freq-wrap">' +
            '<select class="mb-sub__freq" data-mb-freq-for="' + uid + '">' +
              plans.map(function (p) {
                var displayPct = getDisplayPct(p._pct);
                return '<option value="' + p.id + '">' + (p._displayName || p.name) + (displayPct ? ' (save ' + displayPct + '%)' : '') + '</option>';
              }).join('') +
            '</select>' +
          '</div>';

        // Inject practitioner strikethrough price on the upsell tile
        if (IS_PRACT && basePrice > 0) {
          injectPractPrice(tile, basePrice, PRACT_OTP_PCT);
        }

        // Toggle logic
        var labels = el.querySelectorAll('.mb-sub__opt');
        var freqWrap = el.querySelector('.mb-sub__freq-wrap');

        // Find UpCart's native Add button
        var upcartAddBtn = tile.querySelector('.upcart-internal-component__button');

        // Create our own Add button for subscription adds
        var subAddBtn = document.createElement('button');
        subAddBtn.className = 'mb-sub__add-btn';
        subAddBtn.textContent = 'Add to Cart';
        subAddBtn.addEventListener('click', function(e) {
          e.preventDefault();

          // Determine variant
          var vid = null;
          var ourVarSelect = tile.querySelector('[data-mb-variant-select]');
          if (ourVarSelect && ourVarSelect.value) {
            vid = ourVarSelect.value;
          } else {
            var upcartVarSelect = tile.querySelector('.upcart-internal-component-upsell-tile__variant-row select');
            if (upcartVarSelect) {
              vid = upcartVarSelect.value;
            } else {
              vid = String(product.variants[0].id);
            }
          }

          // Get selling plan
          var freqSel = el.querySelector('.mb-sub__freq');
          var sellingPlan = freqSel ? freqSel.value : null;

          if (!vid || !sellingPlan) return;

          var origText = subAddBtn.textContent;
          subAddBtn.textContent = 'Adding…';
          subAddBtn.disabled = true;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: parseInt(vid),
              quantity: 1,
              selling_plan: parseInt(sellingPlan)
            })
          })
          .then(function(r) {
            if (!r.ok) throw new Error('Failed');
            return r.json();
          })
          .then(function() {
            subAddBtn.textContent = 'Added ✓';
            refreshUpcart();
            setTimeout(function() {
              subAddBtn.textContent = origText;
              subAddBtn.disabled = false;
            }, 1500);
          })
          .catch(function() {
            subAddBtn.textContent = 'Error — retry';
            subAddBtn.disabled = false;
            setTimeout(function() { subAddBtn.textContent = origText; }, 2000);
          });
        });

        labels.forEach(function (label) {
          label.addEventListener('click', function (e) {
            labels.forEach(function (l) { l.classList.remove('is-active'); });
            label.classList.add('is-active');
            label.querySelector('input').checked = true;
            var isSubscribe = label.querySelector('input').value === 'subscribe';
            if (isSubscribe) {
              freqWrap.classList.add('is-visible');
              // Hide UpCart's Add, show ours
              if (upcartAddBtn) upcartAddBtn.style.display = 'none';
              subAddBtn.classList.add('is-visible');
              // Update price to subscription discount
              if (IS_PRACT) injectPractPrice(tile, basePrice, PRACT_SUB_PCT);
            } else {
              freqWrap.classList.remove('is-visible');
              // Show UpCart's Add, hide ours
              if (upcartAddBtn) upcartAddBtn.style.display = '';
              subAddBtn.classList.remove('is-visible');
              // Update price to OTP discount
              if (IS_PRACT) injectPractPrice(tile, basePrice, PRACT_OTP_PCT);
            }
          });
        });

        // Insert before the variant-row (which contains the Add button)
        var variantRow = tile.querySelector('.upcart-internal-component-upsell-tile__variant-row');
        if (variantRow) {
          variantRow.parentNode.insertBefore(el, variantRow);
        } else {
          // Fallback: insert before the Add button
          if (upcartAddBtn) {
            upcartAddBtn.parentNode.insertBefore(el, upcartAddBtn);
          } else {
            tile.appendChild(el);
          }
        }

        // Insert our subscription Add button after the toggle
        el.parentNode.insertBefore(subAddBtn, el.nextSibling);

        // Inject variant selector for multi-variant products
        var availableVariants = product.variants.filter(function(v) { return v.available; });
        if (availableVariants.length > 1) {
          var varWrap = document.createElement('div');
          varWrap.className = 'mb-sub__variant-wrap';
          var varSelect = document.createElement('select');
          varSelect.className = 'mb-sub__variant-select';
          varSelect.setAttribute('data-mb-variant-select', '');

          availableVariants.forEach(function(v) {
            var opt = document.createElement('option');
            opt.value = v.id;
            opt.textContent = v.title + ' — ' + money(parseInt(v.price));
            opt.dataset.price = v.price;
            varSelect.appendChild(opt);
          });

          varSelect.addEventListener('change', function() {
            var selectedOpt = varSelect.options[varSelect.selectedIndex];
            var newPrice = parseInt(selectedOpt.dataset.price) || 0;
            var newVid = varSelect.value;

            // Update UpCart's Add button variant ID
            var upcartBtn = tile.querySelector('.upcart-internal-component__button');
            if (upcartBtn) {
              // UpCart stores variant ID in data attributes or onclick
              upcartBtn.setAttribute('data-mb-variant-override', newVid);
            }

            // Update practitioner price if applicable
            if (IS_PRACT && newPrice > 0) {
              var activeToggle = el.querySelector('.mb-sub__opt.is-active input');
              var pct = (activeToggle && activeToggle.value === 'subscribe') ? PRACT_SUB_PCT : PRACT_OTP_PCT;
              injectPractPrice(tile, newPrice, pct);
            }

            // Store current variant for the fetch intercept
            tile.setAttribute('data-mb-current-variant', newVid);
          });

          varWrap.appendChild(varSelect);

          // Insert variant selector before the subscription toggle
          el.parentNode ? el.parentNode.insertBefore(varWrap, el) : tile.insertBefore(varWrap, el);

          // Set initial variant
          tile.setAttribute('data-mb-current-variant', String(availableVariants[0].id));
        }

        // Store plan data on tile for intercept
        tile.setAttribute('data-mb-plans', JSON.stringify(plans.map(function (p) { return { id: p.id, pct: p._pct }; })));
      });
    });
  }

  /* ═══════════════════════════════════════════════
     Scanner — runs on mutation (narrowly scoped)
     ═══════════════════════════════════════════════ */

  var scanTimeout = null;
  var isInjecting = false; // guard to skip our own mutations

  function debouncedScan() {
    if (scanTimeout || isInjecting) return;
    scanTimeout = setTimeout(function () {
      scanTimeout = null;
      isInjecting = true;
      try {
        processCartItems();
        processUpsells();
      } finally {
        // Small delay before unsetting flag so observer
        // ignores the DOM changes we just made
        setTimeout(function() { isInjecting = false; }, 50);
      }
    }, 500);
  }

  function init() {
    injectStyles();

    // Watch only the UpCart container, not the entire body
    var observeTarget = function() {
      var upcartRoot = document.querySelector('#upcart, [class*="upcart-internal"]');
      if (upcartRoot) {
        // Find the outermost UpCart container
        var root = upcartRoot;
        while (root.parentElement && root.parentElement !== document.body &&
               (root.parentElement.id === 'upcart' || (root.parentElement.className || '').indexOf('upcart') !== -1)) {
          root = root.parentElement;
        }
        var observer = new MutationObserver(function(mutations) {
          if (isInjecting) return;
          // Only react to childList mutations (not attribute changes)
          var relevant = mutations.some(function(m) { return m.type === 'childList'; });
          if (relevant) debouncedScan();
        });
        observer.observe(root, { childList: true, subtree: true, attributes: false });
        debouncedScan();
        return true;
      }
      return false;
    };

    // Try immediately, then poll until UpCart mounts
    if (!observeTarget()) {
      var poll = setInterval(function() {
        if (observeTarget()) clearInterval(poll);
      }, 1000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
